// src/components/AvatarPhoto.js
//
// Drop INSIDE an existing avatar circle (the circle must be position:relative
// + overflow:hidden). Fades the member's photo in over the initial that is
// already there; with no url — or if the image fails — it renders nothing, so
// the circle looks exactly as it always has. Decorative (alt=""): the name
// beside every avatar carries the meaning.

import React, { useState, useEffect } from 'react';
import { isRenderablePhotoUrl } from '../services/memberProfiles';

function AvatarPhoto({ url }) {
    const [loaded, setLoaded] = useState(false);
    const [failed, setFailed] = useState(false);

    useEffect(() => { setLoaded(false); setFailed(false); }, [url]);

    if (!url || failed || !isRenderablePhotoUrl(url)) return null;
    return (
        <img
            src={url}
            alt=""
            draggable={false}
            onLoad={() => setLoaded(true)}
            onError={() => setFailed(true)}
            style={{
                position: 'absolute', inset: 0, width: '100%', height: '100%',
                objectFit: 'cover', borderRadius: '50%',
                opacity: loaded ? 1 : 0, transition: 'opacity 0.15s ease',
                pointerEvents: 'none',
            }}
        />
    );
}

export default AvatarPhoto;
